// No React or browser imports: the Vite plugin imports this file in Node.
import type { ArticleMeta } from "../content/articles/meta";

export const SITE_URL = "https://don.evently.ph";
export const OG_IMAGE_URL = `${SITE_URL}/og-image.png`;
export const AUTHOR_NAME = "Don Benary Lagadan";

// Canonical format: no trailing slash.
export const articlesUrl = () => `${SITE_URL}/articles`;
export const articleUrl = (slug: string) => `${SITE_URL}/articles/${slug}`;
export const articleImageUrl = (article: ArticleMeta) =>
  article.cover ? `${SITE_URL}${article.cover.src}` : OG_IMAGE_URL;

export function buildArticleJsonLd(article: ArticleMeta) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: article.title,
    description: article.summary,
    datePublished: article.publishedAt,
    dateModified: article.updatedAt,
    author: {
      "@type": "Person",
      name: AUTHOR_NAME,
      url: `${SITE_URL}/`,
    },
    image: articleImageUrl(article),
    mainEntityOfPage: articleUrl(article.slug),
    url: articleUrl(article.slug),
  };
}
